(() => {
  function initTabs(root = document) {
    root.querySelectorAll('.cp-product-info').forEach(section => {
      if (section.dataset.tabsBound) return;
      section.dataset.tabsBound = 'true';
      const panels = Array.from(section.children).filter(el => el.tagName === 'DETAILS');
      if (!panels.length) return;
      const nav = document.createElement('div');
      nav.className = 'cp-info-tabbar'; nav.setAttribute('role', 'tablist');
      const media = matchMedia('(min-width: 750px)');
      let active = 0;
      const tabs = panels.map((panel, index) => {
        const button = document.createElement('button'); button.type = 'button';
        button.textContent = panel.querySelector('summary').textContent;
        button.id = section.id + '-tab-' + index; panel.id = section.id + '-panel-' + index;
        button.setAttribute('role', 'tab'); button.setAttribute('aria-controls', panel.id);
        button.addEventListener('click', () => {active = index; update();});
        button.addEventListener('keydown', event => {
          let next = active;
          if (event.key === 'ArrowRight') next = (active + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (active - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault(); active = next; update(); tabs[next].focus();
        });
        nav.append(button); return button;
      });
      function update() {
        nav.hidden = !media.matches;
        section.classList.toggle('cp-info-tabs-ready', media.matches);
        panels.forEach((panel, index) => {
          panel.hidden = media.matches && index !== active;
          if (media.matches) {panel.open = true; panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', tabs[index].id);}
          else {panel.removeAttribute('role'); panel.removeAttribute('aria-labelledby'); panel.open = index === active;}
          tabs[index].setAttribute('aria-selected', String(index === active)); tabs[index].tabIndex = index === active ? 0 : -1;
        });
      }
      section.prepend(nav); media.addEventListener('change', update); update();
    });
  }
  function initBundles(root = document) {
    root.querySelectorAll('[data-cp-bundle]').forEach(bundle => {
      if (bundle.dataset.bound) return; bundle.dataset.bound = 'true';
      const form = bundle.querySelector('form'), button = form.querySelector('button[type=submit]');
      const status = bundle.querySelector('[data-bundle-status]');
      const money = new Intl.NumberFormat(bundle.dataset.locale, {style:'currency',currency:bundle.dataset.currency});
      let busy = false;
      const candidates = Array.from(bundle.querySelectorAll('[data-bundle-item]'));
      const terms = value => (value || '').split('|').map(term => term.trim()).filter(Boolean);
      const overlap = (a, b) => terms(a).filter(term => terms(b).includes(term)).length;
      const score = card => {
        let result = overlap(bundle.dataset.currentProfiles, card.dataset.profiles) * 5;
        result += overlap(bundle.dataset.currentGenders, card.dataset.genders) * 3;
        if (bundle.dataset.currentType && bundle.dataset.currentType === card.dataset.type) result += 3;
        if (bundle.dataset.currentVendor && bundle.dataset.currentVendor === card.dataset.vendor) result += 2;
        if (card.dataset.source === 'profile') result += 4;
        if (card.dataset.source === 'type') result += 1;
        return result;
      };
      const ranked = candidates.map(card => ({card, score: score(card)})).sort((a, b) => b.score - a.score);
      const best = ranked[0]?.score || 0;
      let pool = ranked.filter(item => item.score >= best - 6).slice(0, 10);
      if (pool.length < 3) pool = ranked.slice(0, Math.min(8, ranked.length));
      const chosen = [];
      while (pool.length && chosen.length < 3) {
        const weights = pool.map(item => Math.max(1, item.score - best + 8));
        const totalWeight = weights.reduce((sum, weight) => sum + weight, 0);
        let draw = Math.random() * totalWeight;
        let index = weights.findIndex(weight => (draw -= weight) < 0);
        if (index < 0) index = pool.length - 1;
        chosen.push(pool.splice(index, 1)[0].card);
      }
      candidates.forEach(card => {card.hidden = true; card.querySelector('[data-bundle-check]').checked = false;});
      const rail = bundle.querySelector('.cp-discovery-items');
      chosen.slice().reverse().forEach(card => rail.prepend(card));
      chosen.forEach(card => {card.hidden = false; card.querySelector('[data-bundle-check]').checked = true;});
      function items() {return candidates.filter(card => !card.hidden && card.querySelector('[data-bundle-check]').checked && !card.querySelector('[data-bundle-check]').disabled);}
      function update() {
        let total = 0;
        bundle.querySelectorAll('[data-bundle-item]').forEach(card => {const option = card.querySelector('select').selectedOptions[0]; if (option) card.querySelector('[data-bundle-price]').textContent = option.dataset.money;});
        items().forEach(card => total += Number(card.querySelector('select').selectedOptions[0].dataset.price));
        bundle.querySelector('[data-bundle-total]').textContent = money.format(total/100); button.disabled = busy || !items().length;
      }
      form.addEventListener('change', update);
      form.addEventListener('submit', async event => {
        event.preventDefault(); if (busy || !items().length) return;
        const selected = items().map(card => ({id:card.querySelector('select').value,quantity:1}));
        busy = true; update(); status.textContent = ''; button.setAttribute('aria-busy','true');
        try {
          const response = await fetch(bundle.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:selected})});
          const data = await response.json();
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : bundle.dataset.error);
          location.assign(bundle.dataset.cartUrl);
        } catch(error) {status.textContent = error.message || bundle.dataset.error; busy = false; button.removeAttribute('aria-busy'); update();}
      }); update();
    });
  }
  function init(root) {initTabs(root);initBundles(root);}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init(document)); else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();

